import React from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Layout from "./src/layouts/index.js";
import { registerGsapPlugins } from "./src/utils/gsap.js";
import "./src/styles/fonts.css";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onPreRouteUpdate = () => {
  if (typeof window === "undefined") return;
  registerGsapPlugins();
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill(true));
  ScrollTrigger.clearScrollMemory();
  gsap.killTweensOf("*");
};

export const onRouteUpdate = () => {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "production") {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "gatsby-route-change" });
};
